<template>
  <intersect @enter="animate = true">
    <div class="partner-cards" v-if="itemData.length">
      <router-link :to="$store.getters.getSingleUrl(partner, 1)" 
        class="partner-card fadeUp" 
        :class="animate ? 'animate' : ''"
        v-for="(partner, index) in itemData" :key="index">
          <div class="partner-image">
            <picture>
              <source media="(max-width: 767px)" :srcset="_.get(partner, 'list_cover.0.devices.mobile')" />
              <source media="(max-width: 1023px)" :srcset="_.get(partner, 'list_cover.0.devices.tablet')" />
              <img v-if="_.get(partner, 'list_cover.0.devices.desktop')" :src="_.get(partner, 'list_cover.0.devices.desktop')" class="img-absolute" :alt="partner.title" />
            </picture>
          </div>

          <div class="partner-content">
            <!-- {{ $store.state.locale }} -->
            <div class="partner-logo">
              <img v-if="_.get(partner , 'logo')" :src="_.get(partner , 'logo.0.url')" :alt="partner.title" />
            </div>
            
            <div class="partner-text">
              <div class="partner-developer">
                <template v-for="(dev, index) in getDevelopers(partner.developers)">
                  <span v-if="index">-</span>
                  <span>
                    {{ dev.title }}
                  </span>
                </template>
              </div>

              <h2 class="partner-title noto-semibold">{{ partner.title }}</h2>

              <div class="partner-teaser">{{ partner.teaser }}</div>

              <div v-if="partner.status && partner.status !== 'none'" class="partner-status">{{ $fn.tr(partner.status) }}</div>
            </div>
          </div>
      </router-link>
    </div>
    <div class="partner-cards-empty" v-else>
      <h3 class="noto-semibold">{{ $fn.tr("ასეთი ფილტრით პროექტები ვერ მოიძებნა") }}</h3>
    </div>
  </intersect>
</template>

<script>
import Intersect from 'vue-intersect'
export default {
  components: { 
    Intersect
  },
  props: {
    itemData: Array,
  },
  data(){
    return{
      animate: false
    }
  },
  computed: {
    developers() {
      return _.get(this.$store.state.indx, 'terms.developers')
    },
  },
  methods: {
    getDevelopers(ids) {
      if (this.developers.length && ids && ids.length) {
        return this.developers.filter(x => ids.includes(x.id))
      }

      return []
    },
  },
};
</script>
